"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var common_1 = require("@angular/common");
var forms_1 = require("@angular/forms");
var idm_ng_controls_1 = require("@synisys/idm-ng-controls");
var idm_de_service_client_js_1 = require("@synisys/idm-de-service-client-js");
var material_module_1 = require("./material.module");
var controls_1 = require("./controls");
var services_1 = require("./services");
var idm_frontend_shared_1 = require("@synisys/idm-frontend-shared");
var idm_document_service_client_js_1 = require("@synisys/idm-document-service-client-js");
var pipes_1 = require("./pipes");
var material_1 = require("@angular/material");
var idm_entity_search_client_js_1 = require("@synisys/idm-entity-search-client-js");
var ng2_dragula_1 = require("ng2-dragula");
var idm_currency_rate_frontend_1 = require("@synisys/idm-currency-rate-frontend");
var idm_export_templates_service_client_js_1 = require("@synisys/idm-export-templates-service-client-js");
var header_comment_button_component_1 = require("./controls/header-comment-button/header-comment-button.component");
var change_log_component_1 = require("./controls/change-log/change-log.component");
var change_view_component_1 = require("./controls/change-log/change-view.component");
var sis_change_log_diff_node_component_1 = require("./controls/change-log/sis-change-log-diff-node/sis-change-log-diff-node.component");
var change_log_settings_component_1 = require("./controls/change-log/change-log-settings.component");
var dynnamic_controls_routes_1 = require("./dynnamic-controls.routes");
var sis_custom_select_component_1 = require("./controls/custom-select/sis-custom-select.component");
var sis_custom_select_settings_component_1 = require("./controls/custom-select/sis-custom-select-settings.component");
var ɵ0 = services_1.DynamicCommunicationService.createInstance;
exports.ɵ0 = ɵ0;
var DynamicFormControlsModule = /** @class */ (function () {
    function DynamicFormControlsModule() {
    }
    DynamicFormControlsModule = __decorate([
        core_1.NgModule({
            declarations: [
                controls_1.BannerMobileComponent,
                controls_1.InlineSisTableComponent,
                controls_1.InlineSisTableSettingsComponent,
                controls_1.SisTable,
                controls_1.DeleteConfirmDialogComponent,
                controls_1.DynamicPortfolioComponent,
                controls_1.DynamicFilterComponent,
                controls_1.DynamicQuickFilterComponent,
                controls_1.HeaderMobileComponent,
                controls_1.HeaderThreeDotMenuComponent,
                controls_1.HierarchicalDrillDownComponent,
                controls_1.HierarchicalSearchComponent,
                controls_1.HierarchicalSelectComponent,
                controls_1.HierarchicalSelectSettingsComponent,
                controls_1.TooltipComponent,
                controls_1.TooltipSettingsComponent,
                controls_1.SisDocComponent,
                controls_1.SisInlineTableComboBoxComponent,
                controls_1.SisInlineTableMainEntityComponent,
                controls_1.SisSimpleCombo,
                controls_1.SisSimpleTextComponent,
                controls_1.SisSimpleVaryingTextComponent,
                controls_1.SisSingleCheckboxComponent,
                controls_1.SisPipeMsgComponent,
                controls_1.SisCaptionComponent,
                controls_1.SisButtonComponent,
                controls_1.SisBooleanRadioComponent,
                controls_1.SisCheckboxComponent,
                controls_1.SisRadioComponent,
                controls_1.SisTextAreaComponent,
                controls_1.SisTextBoxComponent,
                controls_1.SisWfButtonComponent,
                controls_1.SisDatetimeViewComponent,
                controls_1.WarningButtonComponent,
                controls_1.WarningPopupComponent,
                controls_1.CancelButtonComponent,
                controls_1.CancelWarningPopupComponent,
                controls_1.SisDecimalComponent,
                controls_1.SisIntegerComponent,
                controls_1.SisUserComponent,
                controls_1.SisDateTimePickerComponent,
                controls_1.SisRadioSettingsComponent,
                controls_1.SaveCancelButtonGroupComponent,
                controls_1.SisHeaderViewFormComponent,
                controls_1.HeaderInformationGroupComponent,
                pipes_1.SisValidationMessagePipe,
                controls_1.SisDynamicMultiselectComponent,
                pipes_1.EntityNamePipe,
                controls_1.SisDynamicMultiselectComponent,
                controls_1.HeaderComponent,
                controls_1.HeaderExportButtonComponent,
                controls_1.HeaderSettingsComponent,
                controls_1.EntityFieldViewerComponent,
                controls_1.EntityFieldViewerSettingsComponent,
                controls_1.SisNumberComponent,
                controls_1.SisNumberSettingsComponent,
                pipes_1.SisTranslateMultilingualPipe,
                controls_1.SisHintSettingsComponent,
                controls_1.SisCheckboxSettingsComponent,
                controls_1.SisBooleanRadioSettingsComponent,
                controls_1.SisDateTimeSettingsComponent,
                controls_1.SisDecimalSettingsComponent,
                controls_1.SisDynamicMultiSelectSettingsComponent,
                controls_1.SisIntegerSettingsComponent,
                controls_1.SisSimpleComboSettingsComponent,
                controls_1.SisSingleCheckboxSettingsComponent,
                controls_1.SisTextBoxSettingsComponent,
                controls_1.SisTextAreaSettingsComponent,
                controls_1.SisDocumentDownloadComponent,
                controls_1.MobileCancelButtonComponent,
                pipes_1.TranslateMessageToMultilingualString,
                controls_1.SisTableBuilder,
                controls_1.SisTableSettings,
                controls_1.SisControlLabelSettingsComponent,
                controls_1.SisDynamicDocumentComponent,
                controls_1.SisDocumentSettingsComponent,
                controls_1.SisDynamicChipGroupComponent,
                controls_1.HelperDirective,
                controls_1.ExportCopyTemplateDialogComponent,
                controls_1.SisDynamicEntitySelectComponent,
                header_comment_button_component_1.HeaderCommentButtonComponent,
                change_log_component_1.ChangeLogComponent,
                change_log_settings_component_1.ChangeLogSettingsComponent,
                change_view_component_1.ChangeViewComponent,
                sis_change_log_diff_node_component_1.SisChangeLogDiffTreeNodeComponent,
                sis_custom_select_component_1.SisCustomSelectComponent,
                sis_custom_select_settings_component_1.SisCustomSelectSettingsComponent,
            ],
            entryComponents: [
                controls_1.DeleteConfirmDialogComponent,
                controls_1.CancelWarningPopupComponent,
                controls_1.ExportCopyTemplateDialogComponent,
            ],
            exports: [
                controls_1.BannerMobileComponent,
                controls_1.InlineSisTableComponent,
                controls_1.InlineSisTableSettingsComponent,
                controls_1.SisTable,
                controls_1.SisTableBuilder,
                controls_1.SisTableSettings,
                controls_1.DynamicPortfolioComponent,
                controls_1.DynamicFilterComponent,
                controls_1.DynamicQuickFilterComponent,
                controls_1.HeaderMobileComponent,
                controls_1.HeaderThreeDotMenuComponent,
                controls_1.HierarchicalSelectComponent,
                controls_1.HierarchicalDrillDownComponent,
                controls_1.HierarchicalSelectSettingsComponent,
                controls_1.TooltipComponent,
                controls_1.TooltipSettingsComponent,
                controls_1.SisDocComponent,
                controls_1.SisDocComponent,
                controls_1.SisSimpleCombo,
                controls_1.SisSimpleTextComponent,
                controls_1.SisSimpleVaryingTextComponent,
                controls_1.SisSingleCheckboxComponent,
                controls_1.SisPipeMsgComponent,
                controls_1.SisCaptionComponent,
                controls_1.SisButtonComponent,
                controls_1.SisBooleanRadioComponent,
                controls_1.SisCheckboxComponent,
                controls_1.SisRadioComponent,
                controls_1.SisTextAreaComponent,
                controls_1.SisTextBoxComponent,
                controls_1.SisWfButtonComponent,
                controls_1.SisDatetimeViewComponent,
                controls_1.WarningButtonComponent,
                controls_1.WarningPopupComponent,
                controls_1.CancelButtonComponent,
                controls_1.CancelWarningPopupComponent,
                controls_1.SisDecimalComponent,
                controls_1.SisIntegerComponent,
                controls_1.SisUserComponent,
                controls_1.SisDateTimePickerComponent,
                controls_1.SisRadioSettingsComponent,
                controls_1.SaveCancelButtonGroupComponent,
                controls_1.SisHeaderViewFormComponent,
                controls_1.HeaderInformationGroupComponent,
                controls_1.SisDynamicMultiselectComponent,
                controls_1.SisDynamicMultiselectComponent,
                pipes_1.SisValidationMessagePipe,
                pipes_1.EntityNamePipe,
                controls_1.HeaderComponent,
                controls_1.HeaderExportButtonComponent,
                controls_1.HeaderSettingsComponent,
                controls_1.EntityFieldViewerComponent,
                controls_1.EntityFieldViewerSettingsComponent,
                controls_1.SisNumberComponent,
                controls_1.SisNumberSettingsComponent,
                pipes_1.SisTranslateMultilingualPipe,
                controls_1.SisHintSettingsComponent,
                controls_1.SisCheckboxSettingsComponent,
                controls_1.SisBooleanRadioSettingsComponent,
                controls_1.SisDateTimeSettingsComponent,
                controls_1.SisDecimalSettingsComponent,
                controls_1.SisDynamicMultiSelectSettingsComponent,
                controls_1.SisIntegerSettingsComponent,
                controls_1.SisSimpleComboSettingsComponent,
                controls_1.SisSingleCheckboxSettingsComponent,
                controls_1.SisTextBoxSettingsComponent,
                controls_1.SisTextAreaSettingsComponent,
                controls_1.SisDocumentDownloadComponent,
                controls_1.MobileCancelButtonComponent,
                pipes_1.TranslateMessageToMultilingualString,
                controls_1.SisControlLabelSettingsComponent,
                idm_currency_rate_frontend_1.SisAccountingComponent,
                idm_currency_rate_frontend_1.SisMoneyComponent,
                controls_1.SisDynamicMoneyComponent,
                controls_1.SisMoneySettingsComponent,
                controls_1.SisDynamicAccountingComponent,
                controls_1.SisAccountingSettingsComponent,
                controls_1.SisDynamicDocumentComponent,
                controls_1.SisDocumentSettingsComponent,
                controls_1.SubwayMapComponent,
                controls_1.SisDynamicChipGroupComponent,
                controls_1.SisDynamicEntitySelectComponent,
                header_comment_button_component_1.HeaderCommentButtonComponent,
                change_log_component_1.ChangeLogComponent,
                change_log_settings_component_1.ChangeLogSettingsComponent,
                change_view_component_1.ChangeViewComponent,
                sis_change_log_diff_node_component_1.SisChangeLogDiffTreeNodeComponent,
                sis_custom_select_component_1.SisCustomSelectComponent,
                sis_custom_select_settings_component_1.SisCustomSelectSettingsComponent,
            ],
            imports: [
                forms_1.FormsModule,
                forms_1.ReactiveFormsModule,
                idm_ng_controls_1.ControlsModule,
                common_1.CommonModule,
                idm_de_service_client_js_1.DeControlsModule,
                material_module_1.MaterialModule,
                idm_document_service_client_js_1.DocumentControlsModule,
                idm_entity_search_client_js_1.EntitySearchModule,
                ng2_dragula_1.DragulaModule,
                controls_1.SisDynamicCurrencyModule,
                controls_1.SubwayMapModule,
                idm_frontend_shared_1.SisTranslateModule,
                idm_export_templates_service_client_js_1.ExportTemplatesServiceModule,
                idm_frontend_shared_1.SisUtilitiesModule,
                dynnamic_controls_routes_1.dynamicControlsRouting,
            ],
            providers: [
                {
                    provide: services_1.DynamicCommunicationService,
                    useFactory: ɵ0,
                },
                {
                    provide: material_1.DateAdapter,
                    useClass: idm_ng_controls_1.CustomDateAdapter,
                },
                idm_frontend_shared_1.FormResolverService,
                services_1.ExtractionService,
                controls_1.HierarchicalSearchService,
                services_1.FormattingService,
            ],
        })
    ], DynamicFormControlsModule);
    return DynamicFormControlsModule;
}());
exports.DynamicFormControlsModule = DynamicFormControlsModule;
//# sourceMappingURL=dynamic-controls.module.js.map